/**
 * AI whitelist helper. POSTs /ai/allowed via the app $http, caches the boolean.
 * On failure treat as false; do not toast here (Http interceptor already handles errors).
 */
import { AI_URI } from './aiApi'

var cached = null
var inflight = null

export function fetchAiAllowed (http) {
  if (cached !== null) {
    return Promise.resolve(cached)
  }
  if (inflight) {
    return inflight
  }
  if (!http || typeof http.post !== 'function') {
    cached = false
    return Promise.resolve(false)
  }
  inflight = http.post(AI_URI.allowed, {}).then(function (res) {
    inflight = null
    var allowed = false
    if (res && res.status === 'ok' && res.data && res.data.allowed === true) {
      allowed = true
    }
    cached = allowed
    return cached
  }).catch(function () {
    inflight = null
    cached = false
    return false
  })
  return inflight
}

export function bindAiAllowed (vm) {
  fetchAiAllowed(vm.$http).then(function (allowed) {
    vm.aiAllowed = allowed
    if (allowed) {
      vm.reload = new Date().getTime()
    }
  })
}



// WEBPACK FOOTER //
// ./src/tools/aiAccess.js